package com.gsb.vyapar.bhagya.presentation.admin.util

import androidx.compose.runtime.mutableStateMapOf
import androidx.compose.runtime.snapshots.SnapshotStateMap
import com.gsb.vyapar.bhagya.datasource.network.KtorClient
import com.gsb.vyapar.bhagya.domain.*
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.getState
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.launchDefault
import com.gsb.vyapar.bhagya.interactor.util.hideLoading
import com.gsb.vyapar.bhagya.interactor.util.saveConfig
import com.gsb.vyapar.bhagya.interactor.util.saveInfo
import com.gsb.vyapar.bhagya.interactor.util.showError
import com.gsb.vyapar.bhagya.interactor.util.showLoading
import com.gsb.vyapar.bhagya.presentation.admin.uistate.getAdminUiState
import com.gsb.vyapar.bhagya.presentation.auth.util.getOtherUser
import com.gsb.vyapar.bhagya.util.*

fun saveConfigButton(
    info: String,
    category: String,
    subCategory: String,
    business: String
) {
    if (info.isEmpty() || info.toIntOrNull() == null ||
        category.isEmpty() ||  category.toIntOrNull() == null ||
        subCategory.isEmpty() || subCategory.toIntOrNull() == null ||
        business.isEmpty() || business.toIntOrNull() == null) {
        showError("Fill all the proper details")
    } else {
        val config = mapOf(
            INFO to (info.toIntOrNull() ?: 0),
            CATEGORY to (category.toIntOrNull() ?: 0),
            SUBCATEGORY to (subCategory.toIntOrNull() ?: 0),
            BUSINESS to (business.toIntOrNull() ?: 0)
        )
        saveConfig(config)
        saveConfigToBackend()
    }
}

private fun saveConfigToBackend() {
    showLoading()
    launchDefault {
        var config = getState().getConfig()
        config = config.copy(v = config.v + 1)
        val result = KtorClient.updateConfig(config)
        if (!result.isSuccess) {
            showError("Save Config failed ${result.exceptionOrNull()?.getMessage()}")
        }
        hideLoading()
    }
}

fun saveInfoButton(
    email: String,
    fb: String,
    insta: String,
    x: String,
    share: String,
    about: String,
    support: String,
    terms: String,
    privacy: String,
    upi: String,
    otp: String,
    mobile: String,
    website: String,
    android: String,
    ios: String,
    webapp: String,
    mqttUrl: String,
    mqttPort: String,
    mqttWebPort: String,
    mqttUserName: String,
    mqttPassword: String,
    mqttCertificate: String,
    appVersion: String,
) {
    if (isEmailError(email) || email.isEmpty() ||
        isFbError(fb) || fb.isEmpty() ||
        isInstaError(insta) || insta.isEmpty() ||
        isXError(x) || x.isEmpty() ||
        isDetailError(share) || share.isEmpty() ||
        isDetailError(about) || about.isEmpty() ||
        isDetailError(support) || support.isEmpty() ||
        isWebsiteError(terms) || terms.isEmpty() ||
        isWebsiteError(privacy) || privacy.isEmpty() ||
        isWebsiteError(upi) || upi.isEmpty() ||
        isDetailError(otp) || otp.isEmpty() ||
        isMobileError(mobile) || mobile.isEmpty() ||
        isWebsiteError(website) || website.isEmpty() ||
        isAndroidError(android) || android.isEmpty() ||
        isIosError(ios) || ios.isEmpty() ||
        isWebsiteError(webapp) || webapp.isEmpty() ||
        isMqttUrlError(mqttUrl) || mqttUrl.isEmpty() ||
        isPortError(mqttPort) || mqttPort.isEmpty() ||
        isPortError(mqttWebPort) || mqttWebPort.isEmpty() ||
        isMqttUserNameError(mqttUserName) || mqttUserName.isEmpty() ||
        isMqttPasswordError(mqttPassword) || mqttPassword.isEmpty() ||
        isMqttCertificateError(mqttCertificate) || mqttCertificate.isEmpty() ||
        isAppVersionError(appVersion) || appVersion.isEmpty()) {
        showError("Fill all the details")
    } else {
        val info = mapOf(
            EMAIL to email,
            FACEBOOK to fb,
            INSTAGRAM to insta,
            X to x,
            SHARE to share,
            ABOUT to about,
            SUPPORT to support,
            TERMS to terms,
            PRIVACY to privacy,
            UPI to upi,
            OTP to otp,
            MOBILE to mobile,
            WEBSITE to website,
            ANDROID to android,
            IOS to ios,
            WEB_APP to webapp,
            MQTT_URL to mqttUrl,
            MQTT_PORT to mqttPort,
            MQTT_WEB_PORT to mqttWebPort,
            MQTT_USER_NAME to mqttUserName,
            MQTT_PASSWORD to mqttPassword,
            MQTT_CERTIFICATE to mqttCertificate,
            VERSION to appVersion
        )
        saveInfo(info)
        saveInfoToBackend()
    }
}

private fun saveInfoToBackend() {
    showLoading()
    launchDefault {
        var info = getState().getInfo()
        info = info.copy(v = info.v + 1)
        val result = KtorClient.updateInfo(info)
        if (!result.isSuccess) {
            showError("Save Info failed ${result.exceptionOrNull()?.getMessage()}")
        }
        hideLoading()
    }
}

fun getAllMBusinessUserUI() {
    getAdminUiState().updateUserBusinessMap(mutableStateMapOf())
    showLoading()
    launchDefault {
        val result = KtorClient.getMBusinessAll()
        if (!result.isSuccess) {
            showError("Failed to fetch your pending businesses ${result.exceptionOrNull()?.getMessage()}")
        } else {
            val mBusinessMap = result.getOrNull()
            if (mBusinessMap != null) {
                val userBusinessMap: SnapshotStateMap<User, List<Business>> = mutableStateMapOf()
                mBusinessMap.forEach { businessMap ->
                    getOtherUser(businessMap.key) { user ->
                        if (user != null) {
                            userBusinessMap[user] = businessMap.value.map { it.value.toBusiness() }
                        }
                    }
                }
                getAdminUiState().updateUserBusinessMap(userBusinessMap)
            } else {
                showError("Failed to fetch your pending businesses null")
            }
        }
        hideLoading()
    }
}